// components
import { ActivityIndicator } from '@bosch/react-frok'

// styles
import './ChatLoader.scss'

const ChatLoader = () => {
    return (
        <div className='chat-loader-root'>
            <ActivityIndicator size='medium' />
        </div>
    )
}

export default ChatLoader
